import React, { Component } from 'react';
import * as moment from 'moment';
import 'moment/locale/th';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DateUtil } from '../../utils/dateUtil';
import { NumberUtil } from '../../utils/number-util';

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew-Regular.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

class SalesContractPDF extends Component {
  constructor (props) {
    super(props);
    this.state = {

    }
    this.makePDF = this.makePDF.bind(this)
  }

  componentDidMount () {
    // console.log('SalesContractPDF componentDidMount')
    this.makePDF()
  }

  makePDF() {

    const { car_sell } = this.props
    const printDate = moment().locale('th').format('DD MMM YYYY') + ' ' + moment().format('hh:mm:ss a')
    const car_license_plate = car_sell.car_license_plate_new
    const branch_name = car_sell.branch_name // เจ้าของเต็นท์
    const signatory = car_sell.signatory // เจ้าของเต็นท์
    const branch_type = car_sell.branch_type // นิติบุคคล บุคคลธรรมดา
    const province_name = String(car_sell.province_name_new).trim()
    const date_promise =  moment(car_sell.date_promise).format('DD/MM/YYYY')
    const contact_date = DateUtil.convertShortDateThai(date_promise)

    // customer_name  customer_lastname
    const contact_name = branch_type === 'นิติบุคคล' ? branch_name : signatory
    const customer_name = car_sell.customer_name + ' ' + car_sell.customer_lastname
    const customer_address = car_sell.customer_address
    const car_brand_name = car_sell.car_brand_name
    const car_model = car_sell.car_model_name
    const car_sub_model = car_sell.car_sub_model_name
    let car_name2 = car_model + ' ' +car_sub_model

    /*if (car_sub_model.indexOf(car_model) !== -1) {
      car_name2 = car_sub_model
    }*/

    const car_color_name = car_sell.car_color_name
    const car_num_engines = car_sell.car_num_engines === '' ? '-' : car_sell.car_num_engines // หมายเลขเครื่องยนต์
    const car_number = car_sell.car_number === '' ? '-' : car_sell.car_number// หมายเลขตัวถัง
    const car_miles = NumberUtil.addCommas(car_sell.car_miles)
    //
    const contract_number = car_sell.contract_number // เลขที่สัญญาเช่าซื้อ
    const sum_car_book = car_sell.sum_car_book === 0 ? '-' : NumberUtil.addCommas(car_sell.sum_car_book) // เงินจอง คำนวณที่ SalesContractModal
    const real_sell_price = NumberUtil.addCommas(car_sell.real_sell_price)

    let sum_down_new = Number(car_sell.sum_down) - Number(car_sell.sum_car_book)

    // const sum_down = NumberUtil.addCommas(car_sell.sum_down)
    const sum_down = NumberUtil.addCommas(String(sum_down_new))

    const rate_finance = NumberUtil.addCommas(car_sell.rate_finance)
    const duration_period_name = car_sell.duration_period_name
    const monthly_installment = NumberUtil.addCommas(car_sell.monthly_installment)
    // first_installment
    const first_installment = car_sell.first_installment !== '0000-00-00' ? DateUtil.convertShortDateThai(moment(car_sell.first_installment).format('DD/MM/YYYY')) : '-'

    const pay_every_day = car_sell.pay_every_day === '' ? '................................' : car_sell.pay_every_day
    const pay_last_date = car_sell.pay_last_date === null ? '..................................' : DateUtil.convertShortDateThai(moment(car_sell.pay_last_date).format('DD/MM/YYYY'))

    let car_color = car_color_name
    if (car_color_name.indexOf('สี') === -1){
      car_color = 'สี'+car_color_name
    }

    let spaceParam = '\u00A0 \u00A0 \u00A0 \u00A0'

    let contentInfo = spaceParam + 'สัญญาเช่าซื้อรถยนต์ทะเบียน ' + car_license_plate + ' ' + province_name + '  เลขที่สัญญา '+contract_number+' เมื่อวันที่ '+ contact_date +' ' +
      ' ทำสัญญาที่ ' + branch_name +
      ' ทำขึ้นระหว่าง ' + contact_name + ' ผู้ที่เป็นเจ้าของทรัพย์สินที่ให้เช่าซื้อ ต่อไปนี้ในสัญญาเรียกว่า “เจ้าของ” ฝ่ายหนึ่ง กับ ' + customer_name +
      ' อยู่บ้านเลขที่ ' + customer_address +
      ' ซึ่งต่อไปในสัญญาเรียกว่า “ผู้เช่าซื้อ” อีกฝ่ายหนึ่ง ทั้งสองฝ่ายตกลงทำสัญญากัน ดังต่อไปนี้'

    // \u200B , \u2000

    let order01 = spaceParam + 'ข้อ 1. เจ้าของตกลงให้เช่าซื้อ และผู้เช่าซื้อตกลงเช่าซื้อซึ่ง รถยนต์ ยี่ห้อ ' + car_brand_name +
      ' แบบ/รุ่น ' + car_name2 + ' ' + car_color +
      ' หมายเลขเครื่องยนต์ ' + car_num_engines.toUpperCase() +
      ' หมายเลขทะเบียน ' + car_license_plate + ' ' + province_name +
      ' หมายเลขตัวถังหรือตัวรถ ' + car_number.toUpperCase() +
      ' มีสภาพที่เรียบร้อยและใช้การได้ดี  ได้ใช้งานมาแล้วเป็นระยะทาง ' + car_miles + ' กิโลเมตร' +
      ' ซึ่งต่อไปในสัญญาเรียกว่า “ทรัพย์สินที่เช่าซื้อ” และในวันที่ทำสัญญาเช่าซื้อ ได้รับมอบทรัพย์สินที่เช่าซื้อ ไปแล้วจากเจ้าของ โดยตกลงเช่าซื้อเป็นเงินทั้งสิน จำนวนเงินค่าเช่าซื้อทั้งสิ้น '+real_sell_price+' บาท จำนวนเงินจอง '+sum_car_book+' บาท'

    let order02 = spaceParam + 'ข้อ 2. ผู้เช่าซื้อสัญญาว่าจะชำระค่าเช่าซื้อให้เจ้าของในวันที่ทำสัญญาเป็นจำนวนเงิน '+sum_down+' บาท ' +
      ' ส่วนที่ค้างชำระ เป็นจำนวนเงิน '+rate_finance+' บาท ผู้เช่าซื้อจะนำไปชำระ ณ สถานที่ซึ่งเป็นภูมิลำเนาของเจ้าของ ' +
      ' โดยผู้เช่าซื้อตกลงผ่อน ชำระเป็นงวด เป็นเวลา '+duration_period_name+' เป็นเงินงวดละ '+monthly_installment+' บาท ' +
      ' เริ่มชำระงวดแรกในวันที่ '+first_installment+' งวดต่อๆไปจะชำระทุกวันที่  ' + pay_every_day +
      ' ของเดือนถัดๆไป ติดต่อกันจนครบโดยชำระงวดสุดท้ายในวันที่ ' + pay_last_date

    let order03 = spaceParam + 'สำหรับวิธีคำนวณเงินค่าเช่าซื้อและจำนวนค่าเช่าซื้อจำนวนดอกเบี้ยที่ต้องชำระจำนวนค่าภาษีมูลค่าเพิ่ม ที่ต้องชำระในแต่ละงวด ดังนี้ ( รวมภาษีมูลค่าเพิ่ม )'

    let duration_period_month = car_sell.duration_period_month
    //TODx : ราคาเงินสดส่วนที่เหลือ
    let car_finance_remain = (car_sell.real_sell_price - car_sell.sum_car_book) - sum_down_new //car_sell.sum_down

    let car_finance_remain_text = NumberUtil.addCommas(car_finance_remain)
    let interest_installment = car_sell.interest_installment
    let interest_bath = parseInt(((car_finance_remain*(interest_installment/100))/12)*duration_period_month, 10)

    //insurance_pa ซื้อประกันชีวิตเพิ่ม
    let insurance_pa = car_sell.insurance_pa
    let insurance_pa_buy = car_sell.insurance_pa_buy
    if(insurance_pa_buy === 'PA แถม'){
      insurance_pa = 0
    }

    let sum_remain_pay = car_finance_remain + interest_bath + insurance_pa

    /*let sum_by_pay = Number(duration_period_month) * Number(car_sell.monthly_installment)
    if(sum_remain_pay !== sum_by_pay){

      if(sum_remain_pay > sum_by_pay){
        //insurance_pa = insurance_pa - (sum_remain_pay-sum_by_pay)
        interest_bath = interest_bath - (sum_remain_pay-sum_by_pay)
      }else {
       // insurance_pa = insurance_pa + (sum_by_pay - sum_remain_pay)
        interest_bath = interest_bath + (sum_by_pay - sum_remain_pay)
      }
      sum_remain_pay = sum_by_pay
    }

    if(insurance_pa_buy === 'PA แถม'){
      insurance_pa = 0
    }*/

    let interest_bath_text = NumberUtil.addCommas(interest_bath)
    let insurance_pa_text =  NumberUtil.addCommas(insurance_pa)
    let insurance_pa_detail = car_sell.insurance_pa_detail === null ? '' : car_sell.insurance_pa_detail
    let insurance_pa_note = car_sell.insurance_pa_note === null || car_sell.insurance_pa_note === '' ? '' : 'เงื่อนไข : ' + car_sell.insurance_pa_note
    //let insurance_pa_detail = '(คุ้มครองชีวิต  3 ปี รวมค่าเบี้ย)'
    //let insurance_pa_note = 'เงื่อนไขตามข้อ (8) : หากทางผู้เช่าซื้อค้างชำระค่างวดรถ เกิน 3 งวด ทางบริษัทขอสงวนสิทธิ์งดเว้นการต่อประกันชีวิต'

    let sum_remain_pay_text =  NumberUtil.addCommas(sum_remain_pay)

    let tableCalculate = {
      margin: [0, 0, 0, 6],
      layout: 'noBorders', // optional
      table: {
        widths: ['5%','70%', '15%'  ,'10%'],
        body: [
          [
            { text: '' },
            { text: '(1) ราคาเงินสด' },
            { text: real_sell_price },
            { text: 'บาท' },
          ],
          [
            { text: '' },
            { text: '(2) จำนวนเงินจอง' },
            { text: sum_car_book },
            { text: 'บาท' },
          ],
          [
            { text: '' },
            { text: '(3) จำนวนเงินดาวน์ ' },
            { text: sum_down },
            { text: 'บาท' },
          ],
          [
            { text: '' },
            { text: '(จำนวนเงินดาวน์ไม่รวมภาษีมูลค่าเพิ่ม...................................................บาท)', colSpan: 3  },
            '',
            '',
          ],
          [
            { text: '' },
            { text: '(4) ราคาเงินสดส่วนที่เหลือ (1) – (2) – (3)' },
            { text: car_finance_remain_text },
            { text: 'บาท' },
          ],
          [
            { text: '' },
            { text: '(5) อัตราดอกเบี้ยเช่าซื้อร้อยละ.........'+interest_installment+'...........ต่อปี (คิดดอกเบี้ยแบบ FLAT RATE คืออัตราดอกเบี้ยจากราคาเงินส่วนที่เหลือคงที่ตลอดอายุสัญญา)',  colSpan: 3 },
            '',
            ''
          ],
          [
            { text: '' },
            { text: '(6) จำนวนงวดที่ผ่อนชำระ '+duration_period_name, colSpan: 3 },
            '',
            ''
          ],
          [
            { text: '' },
            { text: '(7) จำนวนดอกเบี้ยที่ชำระ [(4) x (5) ÷ 12] x (6)' },
            { text: interest_bath_text },
            { text: 'บาท' },
          ],
          [
            { text: '' },
            { text: '(8) ค่าประกันชีวิต ' + insurance_pa_detail },
            { text:  insurance_pa_text},
            { text: 'บาท' },
          ],
          [
            { text: '' },
            { text: '(9) จำนวนเงินค่าเช่าซื้อทั้งสิ้น (4) + (7) + (8)' },
            { text:  sum_remain_pay_text },
            { text: 'บาท' },
          ],
          [
            { text: '' },
            { text: '(10) จำนวนค่าเช่าซื้อผ่อนชำระในแต่ละงวด (9)÷(6) หรือ (จำนวนค่างวดแต่ละงวด x จำนวนงวด)', colSpan: 3 },
            '',
            ''
          ],
          [
            { text: '' },
            { text: 'กรณีค่างวดไม่เท่ากัน โดยชำระ งวดที่ 1 ถึงงวดที่.................. ชำระงวดละ.............................บาท จำนวน..............งวด', colSpan: 3 },
            '',
            ''
          ],
          [
            { text: '' },
            { text: 'งวดที่......................... ชำระงวดละ....................................บาท จำนวน...................งวด ', colSpan: 3 },
            '',
            ''
          ],
          [
            { text: '' },
            { text: '(11) จำนวนค่าภาษีมูลค่าเพิ่มต้องชำระในแต่ละงวด (10) x (อัตราภาษีมูลค่าเพิ่ม) ÷100 + ', colSpan: 3 },
            '',
            ''
          ],
        ]
      }
    }

    //ต่อจากข้อ 10 ในหน้าแรก 03-01-2567
    let tableCalculate2 = {
      margin: [0, 0, 0, 6],
      layout: 'noBorders', // optional
      table: {
        widths: ['5%','70%', '15%'  ,'10%'],
        body: [
          [
            { text: '' },
            { text: '(อัตราภาษีมูลค่าเพิ่ม) โดยชำระ งวดที่ 1 ถึงงวดที่................ ชำระงวดละ.............................บาท จำนวน..............งวด ', colSpan: 3 },
            '',
            ''
          ],
          [
            { text: '' },
            { text: 'งวดที่......................... ชำระงวดละ....................................บาท จำนวน...................งวด ', colSpan: 3 },
            '',
            ''
          ],
        ]
      }
    }

    // margin: [left, top, right, bottom]
    let tableSign = {
      margin: [25, 15, 0, 10],
      layout: 'noBorders', // optional
      table: {
        widths: ['15%', '75%', '10%'],
        body: [
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................ผู้เช่าซื้อ', lineHeight:1.5 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................เจ้าของผู้ให้เช่าซื้อ', lineHeight:1.5 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................พยาน', lineHeight:1.5 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................พยาน', lineHeight:1.5 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ข้าพเจ้าผู้ค้ำประกันได้อ่านและเข้าใจข้อความของสัญญาเช่าซื้อดีแล้ว', margin: [0, 10, 0, 20]},
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ......................................................................................ผู้ค้ำประกัน', lineHeight:1.5 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ......................................................................................ผู้ค้ำประกัน', lineHeight:1.5 },
            { text: '' },
          ],
        ]
      }
    }

    let tableInsurancePaNote = {
      margin: [10, 340, 0, 10],
      layout: 'noBorders', // optional
      table: {
        widths: ['*'],
        body: [
          [
            { text: insurance_pa_note}
          ],
        ]
      }
    }



   const pageBreak =  {
       text: '',
       style: 'contentCenterBold',
       pageBreak: 'before',
       pageOrientation: 'portrait'
   }

  // TODO: สัญญาต่อท้ายสัญญาเช่าซื้อ
    const addIn01A = spaceParam + 'ข้อ 1. เจ้าของตกลงให้เช่าซื้อและผู้เช่าซื้อตกลงเช่าซื้อทรัพย์สินที่เช่าซื้อ ซึ่งต่อไปในสัญญานี้จะเรียกว่า “ทรัพย์สินที่เช่าซื้อ” ให้หมายความรวมถึง ส่วนควบ อุปกรณ์ อะไหล่ส่วนที่ตกแต่งติดตั้งเพิ่มเติมด้วยและผู้เช่าซื้อได้รับมอบ ทรัพย์สินที่เช่าซื้อไปจากเจ้าของในสภาพที่ได้ตรวจเป็นที่พอใจแล้ว เป็นการเช่าซื้อทรัพย์สินที่เช่าซื้อตามสภาพขณะทำสัญญา นี้ไม่ว่าจะเป็นทรัพย์สินที่เช่าซื้อใหม่หรือทรัพย์สินที่เช่าซื้อที่ใช้แล้วซึ่งต้องนำไปซ่อมเพื่อใช้งานและผู้เช่าซื้อตกลงสละข้อต่อสู้ เกี่ยวกับสภาพทรัพย์สินที่เช่าซื้อไม่ว่ากรณีใด ๆ'
    const addIn01B = spaceParam + 'ผู้เช่าซื้อตกลงชำระค่าเช่าซื้อ เงินจองและเงินดาวน์ให้แก่เจ้าของตามจำนวนและกำหนดเวลาตามที่กำหนดไว้ ในสัญญา เช่าซื้อทรัพย์สินที่เช่าซื้อ (ในกรณีที่กำหนดชำระของค่างวดเช่าซื้อใดตรงกับวันหยุดทำการของเจ้าของให้ถือ ว่ากำหนดชำระ ของค่างวดเช่าซื้อดังกล่าวถึงกำหนดชำระในวันทำการก่อนหน้าวันหยุดทำการนั้น) โดยชำระ ณ ที่ทำการเจ้าของและผู้เช่าซื้อ มีหน้าที่ตามกฎหมายที่จะต้องชำระ “ภาษีมูลค่าเพิ่ม”  ซึ่งต่อไปในสัญญานี้ให้ หมายความ รวมถึงเบี้ยปรับด้วย โดยชำระให้ แก่เจ้าของ ณ วันถึงกำหนดชำระเงินจำนวนใดๆ ที่ต้องเสียภาษีมูลค่าเพิ่มตามอัตรา ที่ใช้บังคับ ณ วันถึงกำหนดชำระตาม สัญญานี้และภาษีมูลค่าเพิ่มตามที่ ระบุในรายละเอียดข้างต้น เป็นอัตรา ณ วัน ทำสัญญาซึ่งอาจมีการเปลี่ยนแปลงต่อไปตาม ที่กฎหมายกำหนด ทั้งนี้ ภาระหนี้ตามสัญญาเช่าซื้อทรัพย์สินที่เช่าซื้อ ฉบับนี้ปรากฏตามตารางแสดงภาระหนี้ตามสัญญา เช่าซื้อที่แนบท้ายสัญญาฉบับนี้และถือว่าเป็นส่วนหนึ่งของสัญญา เช่าซื้อทรัพย์สินที่เช่าซื้อด้วย'
    const addIn01C = spaceParam + 'ทั้งนี้ เจ้าของมีสิทธิกำหนดให้ผู้เช่าซื้อชำระเงินดาวน์และเงินจองให้แก่ผู้จำหน่ายทรัพย์สินที่เช่าซื้อโดยตรงก็ได้ โดยผู้เช่า ซื้อจะต้องส่งมอบใบเสร็จรับเงินและหลักฐานใบเสร็จรับเงินให้แก่เจ้าของทันที โดยเงินดาวน์และเงินจอง ที่ผู้เช่าซื้อชำระให้แก่ ผู้จำหน่ายทรัพย์สินที่เช่าซื้อถือเป็นเงินที่ชำระแทนเจ้าของ'

    const addIn02A = spaceParam + 'ข้อ 2. กรณีผู้เช่าซื้อเป็นผู้ติดต่อตกลงกับผู้จำหน่ายทรัพย์สินที่เช่าซื้อโดยเจ้าของมิได้เป็นผู้จำหน่ายทรัพย์สิน ที่เช่าซื้อและผู้เช่าซื้อ ขอใช้บริการทางการเงินจากเจ้าของในลักษณะเช่าซื้อ ดังนั้น'
    const addIn02B = spaceParam + spaceParam + '2.1 แม้ผู้เช่าซื้อจะได้ชำระเงินครั้งแรก ( เงินดาวน์ ) และเงินจองหรือชำระราคาบางส่วน ผู้เช่าซื้อตกลง ให้รถตกเป็น กรรมสิทธิ์ของเจ้าของแต่ผู้เดียว หากสัญญานี้เป็นอันสิ้นสุดลงไม่ว่ากรณีใดๆ ผู้เช่าซื้อจะไม่เรียกร้อง เงินดังกล่าวคืนหรือเรียก ค่าเสียหายใดๆ จากเจ้าของ'
    const addIn02C = spaceParam + spaceParam + '2.2 คำรับรอง คำพรรณนา บรรยาย สรรพคุณ คุณภาพ ความเหมาะสม การรับประกันการบริการของ ผู้จำหน่าย หรือผู้ผลิตทรัพย์สินที่เช่าซื้อ หรือบุคคลใดๆ รวมทั้งข้อตกลงใดๆ เกี่ยวกับทรัพย์สินที่เช่าซื้อระหว่างผู้เช่าซื้อกับผู้จำหน่าย ทรัพย์สินที่เช่าซื้อ หากไม่ระบุชัดแจ้งในสัญญานี้จะไม่ผูกพันเจ้าของและเจ้าของไม่รับผิดชอบ ความชำรุดบกพร่องใดๆ ไม่ว่า ตรวจพบขณะส่งมอบหรือไม่ รวมถึงกรณีที่ผู้เช่าซื้อซื้อทรัพย์สินที่เช่าซื้อใช้แล้วและ อาจนำไปซ่อมแซมหรือปรับแต่ง เพื่อการ ใช้งานของผู้เช่าซื้อ ผู้เช่าซื้อตกลงว่าเป็นการเช่าซื้อทรัพย์สินที่เช่าซื้อตาม สภาพและจะไม่ยกเอาปัญหาเรื่องสภาพทรัพย์สิน ที่เช่าซื้อ มาเป็นข้ออ้างในการไม่ปฏิบัติตามข้อตกลงและเงื่อนไข ของสัญญานี้'
    const addIn02D = spaceParam + spaceParam + 'การรับประกันการให้บริการการรับรองคุณภาพรถจากผู้จำหน่ายหรือผู้ผลิตรถไม่ว่าจะมีหรือไม่เพียงใด ผู้เช่าซื้อได้รับทราบเงื่อนไขและสิทธิที่จะได้รับทั้งหมดแล้วและหากเจ้าของได้จัดให้ผู้เช่าซื้อได้ใช้สิทธิในการเรียกร้อง จากผู้จำหน่ายหรือผู้ผลิตรถโดยตรงแล้วเจ้าของไม่ต้องรับผิดชอบเพื่อความชำรุดบกพร่องหรือการรอนสิทธินั้น'
    const addIn02E = spaceParam + spaceParam + '2.3 เมื่อเจ้าของได้ชำระราคารถไปแล้วผู้เช่าซื้อจะไม่ยกเอาเหตุที่ยังไม่ได้รับสำเนาใบคู่มือจดทะเบียนแผ่น ป้ายจดทะเบียน (โลหะ) หลักฐานการชำระภาษีหรือเหตุที่ได้รับล่าช้ามาปฏิเสธการชำระค่าเช่าซื้อหรือไม่ปฏิบัติตาม ข้อตกลงเงื่อนไขของสัญญานี้ทั้งกรณีที่ผู้จำหน่ายรถเป็นผู้ดำเนินการจดทะเบียนให้และในกรณีที่เจ้าของดำเนินการ จดทะเบียนให้แต่ผู้จำหน่ายไม่ส่งใบแจ้งจำหน่ายและเอกสารประกอบการจดทะเบียนมายังเจ้าของหรือส่งมาล่าช้า'
    const addIn02F = spaceParam + spaceParam + 'การจดทะเบียนทรัพย์สินที่เช่าซื้อใหม่ตามวรรคก่อน ต้องระบุชื่อเจ้าของเป็นผู้มีกรรมสิทธิ์ในทะเบียนและ ให้เจ้าของเป็นผู้เก็บรักษาใบคู่มือจดทะเบียนและเป็นหน้าที่ของผู้เช่าซื้อจะต้องตกลงกับผู้จำหน่ายทรัพย์สินที่เช่าซื้อ ให้จดทะเบียนรถเองเว้นแต่เจ้าของตกลงจะดำเนินการจดทะเบียนให้เป็นลายลักษณ์อักษรและไม่ว่ากรณีใด หากครบ 90 วัน นับแต่วันทำสัญญานี้เจ้าของไม่ได้รับใบคู่มือจดทะเบียนทรัพย์สินที่เช่าซื้อด้วยเหตุที่ ผู้เช่าซื้อไม่นำทรัพย์สินที่ เช่าซื้อไปตรวจสภาพหรือดัดแปลงต่อเติมสภาพจนไม่สามารถจดทะเบียนทรัพย์สินที่เช่าซื้อได้เจ้าของมีสิทธิบอกเลิก สัญญานี้ได้ทันที'
    const addIn02G = spaceParam + spaceParam + 'ในกรณีที่ไม่สามารถจดทะเบียนทรัพย์สินเช่าซื้อใหม่ได้ซึ่งไม่ใช่ความผิดของเจ้าของเจ้าของไม่ต้องรับผิด ชอบรวมถึงกรณีไม่สามารถโอนทะเบียนทรัพย์สินที่เช่าซื้อให้ผู้เช่าซื้อได้ภายในกำหนดเวลา ตามข้อ 14. ด้วย'

    const addIn03A = spaceParam + 'ข้อ 3. ผู้เช่าซื้อจะต้องใช้ทรัพย์สินที่เช่าซื้อโดยทะนุถนอมในปกติธุระของผู้เช่าซื้อเอง โดยจะซ่อมแซมบำรุงรักษา เปลี่ยนส่วนควบ และอุปกรณ์ตามอายุที่เหมาะสมให้ทรัพย์สินที่เช่าซื้ออยู่ในสภาพเรียบร้อยใช้การได้ดีเสมือนหนึ่ง เจ้าของทรัพย์สินดูแลทรัพย์สินของตน โดยค่าใช้จ่ายของผู้เช่าซื้อเอง'
    const addIn03B = spaceParam + spaceParam + 'ผู้เช่าซื้อยินยอมให้ผู้ให้เช่าซื้อหรือตัวแทนตรวจดูทรัพย์สินที่เช่าซื้อในเวลาอันสมควร หากปรากฏว่าทรัพย์ สินที่เช่าซื้อชำรุดเสียหายผู้เช่าซื้อตกลงจะต้องซ่อมแซมให้อยู่ในสภาพเรียบร้อยใช้การได้ดีดังเดิม'

    const addIn04A = spaceParam + 'ข้อ 4. ผู้เช่าซื้อจะไม่ใช้และไม่ยินยอมให้บุคคลใดใช้ทรัพย์สินที่เช่าซื้อในลักษณะไม่เหมาะสมผิดประเภทจากการ ออกแบบหรือจดทะเบียน หรือใช้รถในลักษณะที่ก่อให้เกิดความเดือดร้อนรำคาญ แก่ผู้อื่นและไม่ยินยอม ให้ผู้ที่ใช้ ทรัพย์สินที่เช่าซื้อไม่ชำนาญหรือผู้ที่ไม่มีใบอนุญาตในการใช้ทรัพย์สินที่เช่าซื้อ เป็นผู้ใช้ทรัพย์สิน ที่เช่าซื้อและผู้เช่า ซื้อจะไม่หรือยินยอมให้บุคคลใด ลบ ขูด ขีด ทำลาย หมายเลขเครื่องหมาย ของเครื่องยนต์ แชสซีส์หรือตัวถัง หากกระทำดังกล่าวให้ถือว่าผู้เช่าซื้อกระทำผิดสัญญา  เจ้าของมีสิทธิบอกเลิกสัญญาได้ทันที'

    const addIn05A = spaceParam + 'ข้อ 5. ผู้เช่าซื้อจะต้องรับผิดชอบต่อเจ้าของหรือบุคคลใดๆ ในความสูญหายหรือเสียหายใดๆ อันเกิดกับทรัพย์สิน ที่เช่าซื้อ บุคคลใดๆ หรือทรัพย์สินของบุคคลใดๆ อันเนื่องมาจากทรัพย์สินที่เช่าซื้อหรือการใช้ทรัพย์สินที่เช่าซื้อ ทุกกรณีแม้ในเหตุความชำรุดบกพร่องของรถเองหรือในเหตุสุดวิสัย และเมื่อเกิดเหตุดังกล่าวผู้เช่าซื้อจะต้องแจ้ง ให้เจ้าของทราบทันที และจะต้องรับผิดชอบชดใช้ค่าเสียหาย ให้แก่เจ้าของ และ / หรือบุคคลใดๆ นั้นและซ่อมแซม ทรัพย์สินที่เช่าซื้อให้เรียบร้อยดีดังเดิม โดยค่าใช้จ่ายของผู้เช่าซื้อเอง'
    const addIn05B = spaceParam + spaceParam + 'ในกรณีที่ทรัพย์สินที่เช่าซื้อสูญหาย เสียหาย หรือถูกทำลาย จนไม่สามารถซ่อมแซมได้ดีดังเดิมได้ ถูกยึด หรือถูกอายัด โดยเป็นความผิดของผู้เช่าซื้อ ให้ถือว่าสัญญานี้สิ้นสุดลง และผู้เช่าซื้อต้องชดใช่ราคาทรัพย์สินที่เช่า ซื้อตามมูลค่าของทรัพย์สินที่เช่าซื้อ ณ วันที่สูญหาย หรือเสียหายให้แก่เจ้าของ'

    const addIn06A = spaceParam + 'ข้อ 6. หากทรัพย์สินที่เช่าซื้อถูกใช้เป็นพาหนะในการกระทำผิด หรือใช้ทรัพย์สินที่เช่าซื้อในลักษณะที่ ผิดกฎหมาย ระเบียบ คำสั่ง หรือข้อบังคับใดๆ หรือใช้ทรัพย์สินที่เช่าซื้อโดยประการอื่นใด เป็นเหตุให้ทรัพย์สินที่ เช่าซื้อถูกริบ หรือยึด หรืออายัด หรือตกเป็นของรัฐ หรือทรัพย์สินที่เช่าซื้อถูกนำออกหรือพยายาม หรือนำออก นอกราชอาณาจักรไทย หรือนำทรัพย์สินที่เช่าซื้อออกขาย หรือให้ยืม หรือจำนำ  ฝากขายสิทธิ หรือให้บุคคลอื่น รับฝากทรัพย์สิน ที่เช่าซื้อเพื่อโอนสิทธิการเช่าซื้อ หรือให้เช่าช่วง หรือก่อภาระผูกพันหรือกระทำโดยวิธีการใดๆ เพื่อให้ทรัพย์สินที่เช่าซื้อตกไปอยู่ในความครอบครองของ บุคคลภายนอก โดยเป็นความผิดของผู้เช่าซื้อ เจ้าของมีสิทธิบอกเลิกสัญญานี้ได้ทันที และผู้เช่าซื้อต้องแจ้งให้เจ้าของทราบทันทีและผู้เช่าซื้อจะต้องชดใช้ ค่าเสียหายให้แก่เจ้าของตามที่กำหนดไว้ในสัญญาข้อ 5. วรรคสอง'
    const addIn06B = spaceParam + spaceParam + 'กรณีตามวรรคก่อนหากเจ้าของต้องเสียค่าใช้จ่ายไปจริงตามความจำเป็นและมีเหตุผล  อันสมควรในการ ติดต่อขอรับทรัพย์สินที่เช่าซื้อคืนจากบุคคล หรือหน่วยงานที่เกี่ยวข้อง เพื่อให้ได้รับทรัพย์สินที่เช่าซื้อคืน ผู้เช่าซื้อ ตกลงชำระคืนให้แก่เจ้าของจนครบจำนวน ทั้งนี้ เพียงเท่าที่เจ้าของได้ใช้จ่ายไปจริงเพื่อการดังกล่าวตามความจำเป็น และมีเหตุผลอันสมควร'

    const addIn07A = spaceParam + 'ข้อ 7. ผู้เช่าซื้อสัญญาว่าจะประกันภัยทรัพย์สินที่เช่าซื้อประเภทที่หนึ่งครอบคลุมภัยทุกชนิด และประกันภัยตาม พระราชบัญญัติคุ้มครองผู้ประสบภัยจากรถ พ.ศ. 2535 กับผู้รับประกันภัย ซึ่งเจ้าของตกลงยินยอมด้วยโดยผู้เช่าซื้อ เป็นผู้ชำระเบี้ยประกันภัยในทันทีที่ทำสัญญานี้ และตลอดไปจนกว่ากรรมสิทธิ์ในทรัพย์สินที่เช่าซื้อจะตกเป็นของผู้ เช่าซื้อตามสัญญานี้ โดยให้มีวงเงินเอาประกันภัยจำนวนไม่น้อยกว่าค่า เช่าซื้อส่วนที่ยังไม่ได้ชำระตามสัญญานี้และ ไม่มีข้อจำกัดสิทธิใดๆ โดยระบุให้เจ้าของเป็นผู้รับประโยชน์และเป็นผู้เก็บรักษากรมธรรม์ ทั้งนี้ โดยผู้เช่าซื้อในฐานะ ผู้เอาประกันภัยต้องปฏิบัติตามเงื่อนไขที่ระบุไว้ในกรมธรรม์โดยเคร่งครัด ในกรณีที่ทรัพย์สินที่เช่าซื้อเสียหายหรือ สูญหาย แม้จะเกิดขึ้นระหว่างทรัพย์สินที่ เช่าซื้ออยู่ในความครอบครองของบุคคลใดๆ ไม่ว่าผู้รับประกันภัยหรือ บุคคลใดๆ จะซ่อมแซมหรือชดใช้ค่าเสียหายให้เพียงใด ผู้เช่าซื้อยังคงต้องรับผิดต่อเจ้าของตามสัญญานี้'
    const addIn07B = spaceParam + spaceParam + 'กรณีที่ทรัพย์สินที่เช่าซื้อสูญหายหรือเสียหายสิ้นเชิงและเจ้าของได้รับประโยชน์ตามกรมธรรม์ประกันภัย เพื่อชำระหนี้เท่ากับจำนวนหนี้คงค้างชำระตามสัญญานี้ โดยให้ส่วนลดดอกเบี้ยเช่าซื้อตามที่ ระบุไว้ในข้อ 16. วรรคท้ายเรียบร้อยแล้ว หากมีเงินเหลืออยู่เท่าใดให้ตกแก่ผู้เช่าซื้อ โดยเจ้าของจะดำเนินการให้ผู้รับประกันภัย ชำระเงินที่เหลือดังกล่าวแก่ผู้เช่าซื้อ'
    const addIn07C = spaceParam + spaceParam + 'หากผู้เช่าซื้อไม่ชำระค่าเบี้ยประกันภัยตามกำหนด ไม่ว่าจะเป็นเบี้ยประกันภัยปีแรก หรือปีต่อๆ ไป จนเป็นเหตุให้กรมธรรม์ประกันภัยขาดความคุ้มครองหรือผู้เช่าซื้อยกเลิกเพิกถอนกรมธรรม์ โดยไม่ได้รับความ ยินยอมล่วงหน้าเป็นลายลักษณ์อักษรจากเจ้าของให้ถือว่าผิดสัญญาในข้อสาระสำคัญเจ้าของมีสิทธิบอกเลิกสัญญาได้ หรือมีสิทธินำเงินจำนวนใดๆ ที่ได้รับจากผู้เช่าซื้อมาหักชำระเบี้ยประกันภัยเฉพาะส่วนประกันภัยตามพระราชบัญญัติ คุ้มครองผู้ประสบภัยจากรถ พ.ศ. 2553 ได้'

    const addIn08A = spaceParam + 'ข้อ 8. ค่าภาษีมูลค่าเพิ่ม ค่าภาษีรถประจำปี เงินเพิ่มเนื่องจากการต่อภาษีล่าช้า ค่าธรรมเนียมเปลี่ยนเครื่องยนต์ สีรถ ชนิดเชื้อเพลิง (ต่อรายการ) ค่าธรรมเนียมโอนทะเบียนรถยนต์ค่าธรรมเนียมแผ่นป้ายทะเบียนรถ ค่าธรรมเนียม ใบแทนเครื่องหมายแสดงการเสียภาษีรถ ค่าปรับเนื่องจากการเปลี่ยนเครื่องยนต์ สีรถ ชนิดเชื้อเพลิงและค่าเบี้ย ประกันภัยตามกฎหมายว่าด้วยการคุ้มครองผู้ประสบภัยจากรถและค่าใช้จ่ายอื่นใดที่กรมการขนส่งทางบกเรียกเก็บ ผู้เช่าซื้อจะเป็นผู้ชำระอย่างไรก็ตามในกรณีผู้เช่าซื้อค้างชำระค่าเช่าซื้อหรือประพฤติผิดสัญญานี้ เจ้าของมีสิทธิระงับ การต่อภาษีประจำปีหรือระงับการส่งมอบเอกสารแสดงการเสียภาษีประจำปี หรือเอกสารจำเป็นในการใช้รถจนกว่า ผู้เช่าซื้อจะชำระหนี้ครบถ้วน'
    const addIn08B = spaceParam + spaceParam + 'กรณีผู้เช่าซื้อดัดแปลงต่อเติมทรัพย์ที่เช่าซื้อหลังจากที่ได้ทำสัญญานี้ ไม่ว่าจะได้รับอนุญาตจากเจ้าของ หรือไม่ หากเข้าข่ายที่จะต้องชำระภาษีตามกฎหมาย ระเบียบ หรือคำสั่งอื่นใด ผู้เช่าซื้อจะต้องเป็นผู้ชำระทั้งสิ้น และหากการกระทำดังกล่าวทำให้ไม่สามารถโอนทะเบียนทรัพย์สินที่เช่าซื้อเป็นชื่อของผู้เช่าซื้อตามสัญญานี้ผู้เช่าซื้อ ต้องรับผิดชอบแก้ไขเปลี่ยนแปลงเพื่อให้คืนสภาพเดิมด้วยค่าใช้จ่ายของผู้เช่าซื้อเอง'
    const addIn08C = spaceParam + spaceParam + 'กรณีนำรถเข้าจากต่างประเทศ ผู้เช่าซื้อได้สอบถามผู้จำหน่ายรถและตรวจสอบโดยละเอียดแล้วจึงขอ รับรองว่ารถได้มีการชำระค่าอากรนำเข้า ภาษีมูลค่าเพิ่ม หรือภาษีอากร หรือค่าธรรมเนียม ที่เกี่ยวข้องและ ค่าใช้จ่ายอื่นๆ โดยผ่านพิธีการทางศุลกากรครบถ้วนถูกต้องแล้ว'

    const addIn09A = spaceParam + 'ข้อ 9. เงินจำนวนใดๆ ที่เจ้าของรับจากผู้เช่าซื้อ ผู้เช่าซื้อตกลงยินยอมให้เจ้าของจัดสรรเป็นภาษีมูลค่าเพิ่มที่ผู้เช่า ซื้อต้องชำระหรือที่เจ้าของชำระแทนไป ค่าใช้จ่ายใดๆ ที่เจ้าของได้ชำระไปแทน ผู้เช่าซื้อและผู้เช่าซื้อเป็นผู้มีหน้าที่ ชำระตามกฎหมายหรือตามสัญญานี้ และ / หรือเบี้ยปรับของเงินที่ค้างชำระก่อน หลังจากนั้นจะจัดสรรชำระหนี้ใดๆ ซึ่งผู้เช่าซื้อจะต้องชำระตามสัญญานี้ โดยเฉพาะอย่างยิ่ง ค่าเช่าซื้อ ให้จัดสรรเป็นเงินค่าเช่าซื้องวดที่คงค้างชำระอยู่ ก่อนที่สุดและนานที่สุดตามลำดับ'
    const addIn09B = spaceParam + spaceParam + 'ในกรณีที่เจ้าของประสงค์จะนำเงินค่างวดของผู้เช่าซื้อในงวดต่อมา มาหักชำระค่าใช้จ่ายที่เจ้าของเรียกเก็บ ได้ตามสัญญานี้ ซึ่งผู้เช่าซื้อต้องชำระในแต่ละงวด ค่าธรรมเนียม หรือค่าใช้จ่ายใดๆ ในการทวงถามหนี้ค่าเช่าซื้อ ค่าเบี้ยปรับชำระค่างวดล่าช้า เจ้าของจะต้องมีหนังสือแจ้งให้ผู้เช่าซื้อทราบก่อน ภายใน 7 (เจ็ด) วัน นับแต่วันที่ผู้เช่า ซื้อได้รับแจ้ง แต่ถ้าเจ้าของไม่มีหนังสือดังกล่าว เจ้าของไม่มีสิทธินำเงินค่าเช่าซื้องวดต่อมา มาหักชำระค่าใช้จ่าย ดังกล่าว และเจ้าของจะถือว่าผู้เช่าซื้อผิดนัดชำระค่าเช่าซื้อที่นำมาชำระเต็มจำนวนในงวดนั้นไม่ได้'
    const addIn09C = spaceParam + spaceParam + 'หากเจ้าของได้หักเงินค่างวดตามวรรคสองแล้ว เจ้าของมีหน้าที่แจ้งเป็นหนังสือให้ผู้เช่าซื้อนำเงินในส่วน ที่ขาดของค่างวดเช่าซื้อนั้น มาชำระให้ครบถ้วนภายใน 15 (สิบห้า) วัน นับแต่วันที่ผู้เช่าซื้อได้รับหนังสือดังกล่าว หากผู้เช่าซื้อมิได้ชำระเงินส่วนที่ขาดให้ครบถ้วนภายในกำหนดระยะเวลาดังกล่าว ให้ถือว่าผู้เช่าซื้อผิดนัดเฉพาะเงิน ค่างวดเช่าซื้อบางส่วนที่ยังไม่ได้ชำระนั้น'
    const addIn09D = spaceParam + spaceParam + 'อนึ่ง ค่าธรรมเนียม หรือค่าใช้จ่ายใดๆ ในการทวงถามหนี้ค่าเช่าซื้อ ตามวรรคสอง หมายความว่า เงินที่ เจ้าของเรียกเก็บจากผู้เช่าซื้อ เพื่อเป็นค่าบริการหรือค่าใช้จ่ายในการติดตามทวงถามหนี้เงินค่างวดเช่าซื้อทรัพย์สิน ที่เช่าซื้อตามกฎหมายว่าด้วยการทวงถามหนี้'

    const addIn10A = spaceParam + 'ข้อ 10. นอกจากสัญญานี้จะสิ้นสุดลงตามข้ออื่นๆ ของสัญญานี้แล้ว สัญญานี้ย่อมสิ้นสุดลงโดยเหตุดังต่อไปนี้'
    const addIn10B = spaceParam + spaceParam + '10.1 ผู้เชำซื้อผิดนัดไม่ชำระค่าเช่าซื้อ 3 งวดติดต่อกัน เจ้าของจะบอกกล่าวเป็นหนังสือให้ผู้เช่าซื้อชำระ ค่าเช่าซื้อที่ค้างชำระนั้นภายในเวลาอย่างน้อย 30 (สามสิบ) วัน นับแต่วันที่ผู้เช่าซื้อได้รับหนังสือหากผู้ซื้อไม่ชำระ ค่าเช่าซื้อพร้อมภาษีมูลค่าเพิ่ม เบี้ยปรับ ค่าใช้จ่าย หรือเงินใดๆ ที่ต้องชำระให้ครบจำนวนทันงวด ณ วันที่ชำระ ให้ถือว่าสัญญานี้สิ้นสุดลงทันที'
    const addIn10C = spaceParam + spaceParam + 'หากผู้เช่าซื้อไม่อาจชำระค่าเช่าซื้อตามวรรคก่อนได้ และจัดหาบุคคลภายนอกซึ่งมีคุณสมบัติครบถ้วน ตามหลักเกณฑ์ที่เจ้าของกำหนดเป็นการทั่วไปในการประกอบกิจการให้เช่าซื้อตามปกติเพื่อรับโอนสิทธิและหน้าที่ ตามสัญญานี้ โดยต้องทำสัญญาโอนสิทธิและหน้าที่ให้เรียบร้อยพร้อมทั้งชำระเงินจำนวนตามวรรคก่อนให้แก่เจ้าของ จนครบถ้วน รวมทั้ง ค่าภาษี ค่าอากร ค่าใช้จ่าย หรือเงินอื่นใดที่เจ้าของต้องชำระเพิ่มเนื่องจากการโอนสิทธิ แม้ตาม กฎหมายกำหนดให้เจ้าของเป็นผู้ชำระและค่าธรรมเนียมการโอนสิทธิตามสัญญานี้ ทั้งนี้ เพียงเท่าที่เจ้าของได้ใช้จ่าย ไปจริงเพื่อการดังกล่าว ตามความจำเป็นและมีเหตุผลอันสมควร ภายในกำหนดระยะเวลาตามวรรคก่อนเรียบร้อย แล้ว สัญญานี้จึงจะไม่สิ้นสุด'
    const addIn10D = spaceParam + spaceParam + '10.2 กรณีที่ผู้เช่าซื้อมีหนี้สินล้นพ้นตัวหรือถูกศาลสั่งพิทักษ์ทรัพย์ หรือผู้ค้ำประกันถึงแก่กรรมหรือถูกศาล สั่งพิทักษ์ทรัพย์เด็ดขาดหรือเป็นบุคคลล้มละลาย หรือถูกศาลสั่งให้เป็นบุคคลไร้ความสามารถหรือเสมือนไร้ความ สามารถ และผู้เช่าซื้อไม่จัดหาบุคคลอื่นใดซึ่งเจ้าของได้ตรวจพิจารณาเห็นว่าเป็นผู้มีคุณสมบัติครบถ้วนตามข้อ กำหนดของเจ้าของมาค้ำประกันแทนภายใน 30 (สามสิบ) วัน นับแต่ผู้ค้ำประกันถึงแก่กรรม หรือถูกศาลสั่งพิทักษ์ ทรัพย์เด็ดขาด หรือเป็นบุคคลล้มละลาย หรือถูกศาลสั่งให้เป็นบุคคลไร้ความสามารถ หรือเสมือนไร้ความสามารถ ให้ถือว่าสัญญานี้สิ้นสุดลงทันที'
    const addIn10E = spaceParam + spaceParam + '10.3 กรณีที่ผู้เช่าซื้อถึงแก่กรรม เมื่อเจ้าของทราบ เจ้าของจะแจ้งเป็นหนังสือไปยังทายาทคนใดคนหนึ่ง เพื่อให้ทายาทเข้ารับโอนสิทธิตามสัญญาเช่าซื้อนี้ภายในกำหนด 30 ( สามสิบ ) วัน นับตั้งแต่วันที่ทายาทได้รับ หรือถือว่าได้รับหนังสือ หากทายาทเพิกเฉยไม่เข้าทำสัญญารับโอนสิทธิ เจ้าของมีสิทธิบอกเลิกสัญญานี้ได้ทันที'
    const addIn10F = spaceParam + spaceParam + '10.4 กรณีที่ผู้เช่าซื้อกระทำหรือยอมให้ผู้อื่นกระทำการดัดแปลง ต่อเติม หรือกระทำประการอื่นใดจนเป็น เหตุให้ทรัพย์สินที่เช่าซื้อเสื่อมสภาพหรือเสื่อมราคาลงเกินกว่าการใช้สอยตามปกติเยี่ยง วิญญูชนพึงกระทำ ให้ถือว่า สัญญานี้สิ้นสุดลงทันที'
    const addIn10G = spaceParam + spaceParam + '10.5 กรณีที่ผู้เช่าซื้อไม่รักษาและปฏิบัติตามข้อตกลง เงื่อนไขข้อผูกพันใดๆ และข้อกำหนดใดๆ อันเป็นหน้าที่ของตนตามที่ระบุในสัญญานี้ให้ผู้ให้เช่าซื้อมีสิทธิบอกเลิกสัญญาเช่าซื้อได้ทันที'
    const addIn10H = spaceParam + spaceParam + 'การสิ้นสุดของสัญญาดังกล่าวไม่มีผลยกเลิกหรือลบล้างสิทธิเรียกร้องของเจ้าของและความรับผิดของ ผู้เช่าซื้อในบรรดาค่าเสียหาย ค่าใช้ทรัพย์ ค่าขาดประโยชน์ที่เจ้าของควรได้รับ ภาษีมูลค่าเพิ่มตามจำนวนที่เจ้าของ ได้ชำระไป เบี้ยปรับ ค่าใช้จ่าย เงินจำนวนใดๆ ตามกำหนดในสัญญานี้ หรือที่ผู้เช่าซื้อต้องชำระตามกฎหมายเพียง เท่าที่เจ้าของได้ใช้จ่ายไปจริง โดยประหยัด ตามความจำเป็นและมีเหตุผลอันสมควร'


    const addIn11A = spaceParam + 'ข้อ 11. เมื่อสัญญานี้สิ้นสุดลงตามข้อ 10. หรือข้ออื่นๆ ของสัญญานี้ หรือในกรณีใดๆ ผู้เช่าซื้อ มีหน้าที่ที่จะต้อง ส่งมอบทรัพย์สินที่เช่าซื้อคืนให้แก่เจ้าของ ณ ภูมิลำเนาของเจ้าของในสภาพเรียบร้อย และใช้การได้ดีทันทีด้วยค่าใช้ จ่ายของผู้เช่าซื้อเอง หากผู้เช่าซื้อไม่ส่งมอบทรัพย์สินที่เช่าซื้อคืนให้เจ้าของหรือผู้มีอำนาจกระทำการแทนเจ้าของ มีสิทธิติดตาม ยึด กลับเข้าครอบครองทรัพย์สินที่เช่าซื้อได้ทันที โดยมีสิทธิเข้าไปในสถานที่ใดๆ ซึ่งผู้เช่าซื้ออาศัย ครอบครองหรือเป็นเจ้าของ หรือสถานที่ใดๆ ซึ่งทรัพย์สินที่เช่าซื้ออาจอยู่ในที่นั้นได้ และหากผู้เช่าซื้อครอบครองและ ใช้ทรัพย์สินที่เช่าซื้อโดยไม่ชำระค่าเช่าซื้อก่อนสัญญานี้สิ้นสุดลง และหลังสัญญานี้สิ้นสุดลง โดยเจ้าของยังไม่ได้รับ ทรัพย์สินที่เช่าซื้อคืนไม่ว่ากรณีใดๆ ผู้เช่าซื้อจะต้องชำระ ค่าใช้ทรัพย์ ค่าขาดประโยชน์หรือค่าเสียหายเป็นรายเดือน รวมทั้งชำระภาษีมูลค่าเพิ่มตามจำนวนที่เจ้าของได้ชำระไป ทั้งนี้ เพียงเท่าที่เจ้าของได้ใช้จ่ายไปจริง โดยประหยัด ตามความจำเป็นและมีเหตุผลอันสมควร และผู้เช่าซื้อต้องรับผิดชอบต่อความชำรุดบกพร่อง ค่าเสื่อมราคาและ ค่าเสียหายใดๆ อันเกิดแก่ทรัพย์สินที่เช่าซื้อด้วย โดยเจ้าของมีสิทธิริบเงินค่าเช่าซื้อ และ / หรือเงินจำนวนใดๆ ซึ่งผู้เช่าซื้อชำระให้แก่เจ้าของแล้วทั้งหมดด้วย ทั้งนี้ เพียงเท่าที่เจ้าของได้ใช้จ่ายไปจริง โดยประหยัดตามความจำเป็น และมีเหตุผลอันสมควร'
    const addIn11B = spaceParam + spaceParam + 'เมื่อสัญญานี้สิ้นสุดลง ผู้เช่าซื้อสัญญาว่าจะต้องเอาทรัพย์สินต่างๆ ของผู้เช่าซื้อหรือของบุคคลใดๆ ออกจากทรัพย์สินที่เช่าซื้อหากผู้เช่าซื้อไม่ยอมเอาทรัพย์สินของผู้เช่าซื้อหรือของบุคคลใดๆ ออกจากทรัพย์สิน ที่เช่าซื้อให้หมดแล้ว เมื่อเจ้าของ ผู้แทน หรือลูกจ้างของเจ้าของเข้ายึดถือครอบครองทรัพย์สินที่เช่าซื้อ ให้ถือว่า ผู้เช่าซื้อหรือเจ้าของทรัพย์นั้น ยอมให้เจ้าของ ผู้แทน หรือลูกจ้างของเจ้าของนำทรัพย์สินดังกล่าวไปได้ด้วยโดยไม่มี เจตนาทุจริตทรัพย์สินใดๆ (ถ้ามี) ที่ติดมากับทรัพย์สินที่เช่าซื้อ ผู้เช่าซื้อตกลงให้เจ้าของ ผู้แทน หรือลูกจ้างของ เจ้าของนำทรัพย์สินดังกล่าวไปฝากไว้กับบุคคลใดๆ หรือไม่ก็ได้ตาม แต่เจ้าของจะเห็นสมควรด้วยค่าใช้จ่ายของ ผู้เช่าซื้อเอง'

    const addIn12A = spaceParam + 'ข้อ 12. ผู้เช่าซื้อยินยอมให้ส่วนควบหรืออุปกรณ์ใดๆ ที่ติดตั้งกับทรัพย์สินที่เช่าซื้อไม่ว่าก่อนหรือหลังวันทำ สัญญานี้ตกเป็นกรรมสิทธิ์ของเจ้าของทันที โดยจะไม่เรียกร้องหรือขอให้ชดใช้ราคาแต่ประการใด หากการเปลี่ยนแปลงหรือหาของใหม่มาทดแทน ของผู้เช่าซื้อเป็นเหตุให้ราคาทรัพย์สินที่เช่าซื้อลดน้อยถอยลง ผู้เช่าซื้อจะต้องรับผิดชอบชดใช้ราคาทรัพย์สินที่เช่าซื้อส่วนที่ลดน้อยถอยลงให้แก่เจ้าของทรัพย์สินที่เช่าซื้อด้วย'

    const addIn13A = spaceParam + 'ข้อ 13. กรณีที่สัญญานี้สิ้นสุดลงไม่ว่ากรณีใดๆ และเจ้าของได้ทรัพย์สินที่เช่าซื้อกลับคืนมา ก่อนนำทรัพย์สิน ที่เช่าซื้อออกขายโดยวิธีประมูลหรือขายทอดตลาดที่เหมาะสม เจ้าของตกลงว่าจะต้องดำเนินการตามลำดับ ดังต่อไปนี้'
    const addIn13B = spaceParam + spaceParam + '13.1 เจ้าของต้องมีหนังสือแจ้งให้ผู้เช่าซื้อทราบล่วงหน้า ไม่น้อยกว่า 7 (เจ็ด) วัน เพื่อให้ผู้เช่าซื้อใช้สิทธิ ซื้อรถก่อนได้ ตามมูลหนี้ส่วนที่ขาดอยู่ตามสัญญาเช่าซื้อ และได้รับส่วนลดตามอัตราและการคิดคำนวณตามข้อ 16. หากผู้เช่าซื้อไม่ใช้สิทธิดังกล่าวภายในกำหนดระยะเวลานั้น เจ้าของจะมีหนังสือแจ้งให้ผู้ค้ำประกันทราบเป็นระยะ เวลาไม่น้อยกว่า 15 (สิบห้า) วัน นับแต่วันที่สิ้นสุดระยะเวลาการใช้สิทธิของ ผู้เช่าซื้อ เพื่อให้ผู้ค้ำประกันใช้สิทธินั้น โดยผู้ค้ำประกันได้รับสิทธิเช่นเดียวกับผู้เช่าซื้อ'
    const addIn13C = spaceParam + spaceParam + 'หากเจ้าของไม่ปฏิบัติตามวิธีการตามวรรคก่อน เจ้าของตกลงรับผิดในความเสียหายที่เกิดขึ้นจากเหตุของ การไม่ได้แจ้งแก่ผู้เช่าซื้อหรือผู้ค้ำประกัน แล้วแต่กรณี'
    const addIn13D = spaceParam + spaceParam + '13.2 เจ้าของต้องมีหนังสือแจ้งให้ผู้เช่าซื้อและผู้ค้ำประกัน (ถ้ามี) ทราบล่วงหน้าไม่น้อยกว่า 7 (เจ็ด) วัน ก่อนวันประมูลขาย หรือวันขายทอดตลาด ทั้งนี้ ในหนังสือแจ้งนั้น อย่างน้อยต้องระบุ ชื่อผู้ทำการขาย วันและสถาน ที่ที่ทำการขาย ในแต่ละครั้งไว้ในหนังสือฉบับเดียวกันก็ได้'
    const addIn13E = spaceParam + spaceParam + 'โดยการประมูลขาย หรือขายทอดตลาด ทรัพย์สินที่เช่าซื้อของผู้เช่าซื้อดังกล่าว ผู้ให้เช่าซื้อตกลงที่จะไม่เข้า สู้ราคาไม่ว่าจะโดยทางตรงหรือโดยวิธีทางใดก็ตาม'
    const addIn13F = spaceParam + spaceParam + 'ทั้งนี้ หากทรัพย์สินที่เช่าซื้อที่นำออกขายตามวิธีการดังกล่าว ได้ราคาเกินกว่าจำนวนหนี้ คงค้างชำระตาม สัญญานี้ เจ้าของจะคืนเงินส่วนเกินนั้นให้แก่ผู้เช่าซื้อ แต่หากได้ราคาน้อยกว่าจำนวนหนี้ คงค้างชำระ ตามสัญญานี้ ผู้เช่าซื้อตกลงรับผิดส่วนที่ขาดนั้น'
    const addIn13G = spaceParam + spaceParam + '13.3 ภายหลังจากที่เจ้าของขายทรัพย์สินที่เช่าซื้อโดยวิธีประมูลหรือขายทอดตลาดได้แล้วเจ้าของจะต้องมี หนังสือแจ้ง ชื่อผู้ทำการขาย วัน สถานที่ที่ทำการขาย ราคาที่ขายได้ และรายละเอียดค่าใช้จ่ายเกี่ยวกับการขายเพียง เท่าที่ได้ใช้จ่ายไปจริงโดยประหยัดตามความจำเป็นและมีเหตุผลสมควรรวมทั้งจำนวนเงินส่วนเกินที่คืนให้แก่ผู้เช่าซื้อ หรือจำนวนเงินที่ผู้เช่าซื้อต้องรับผิดในส่วนที่ขาดอยู่ตามสัญญาให้ผู้เช่าซื้อทราบภายใน 15 (สิบห้า) วัน นับแต่วันที่ทำการขาย ทั้งนี้ ผู้เช่าซื้อจะไม่ได้รับส่วนลดตามอัตราและการคิดคำนวณตามข้อ 16. วรรคท้าย'
    const addIn13H = spaceParam + spaceParam + 'ทั้งนี้จำนวนเงินที่ผู้เช่าซื้อต้องรับผิดในส่วนที่ขาดอยู่ตามสัญญาข้างต้นจะคำนวณจากเงินค่างวดที่ค้างชำระ และเงินค่างวดที่ยังไม่ถึงกำหนดชำระที่ผู้เช่าซื้อมีหน้าที่ต้องชำระให้กับเจ้าของตามสัญญาเช่าซื้อและให้หมายรวมถึง เงินค่าปรับ หรือค่าธรรมเนียม หรือค่าใช้จ่ายใดๆ ในการทวงถามหนี้ค่าเช่าซื้อทั้งนี้ เพียงเท่าที่เจ้าของได้ใช้จ่ายไปจริง โดยประหยัด ตามความจำเป็นและมีเหตุอันสมควร'

    const addIn14A = spaceParam + 'ข้อ 14. ผู้เช่าซื้อจะบอกเลิกสัญญา เช่าซื้อในเวลาใดๆ เสียก็ได้โดยผู้เช่าซื้อจะต้องคืนและส่งมอบทรัพย์สินที่เช่า ซื้อในสภาพที่ซ่อมแซมเรียบร้อยใช้การได้ดีในสภาพเช่นเดียวกับวันที่รับมอบทรัพย์สินที่เช่าซื้อไปจากผู้ให้เช่าซื้อ พร้อมทั้งอุปกรณ์และอะไหล่ทั้งหมดให้แก่ผู้ ให้เช่าซื้อ ณ ที่ทำการของผู้ให้เช่าซื้อและชำระเงินทั้งปวงที่ถึงกำหนด ชำระหรือเป็นหนี้ตามสัญญานี้อยู่ในเวลานั้นทันทีภายใต้ความเสี่ยงภัยและค่าใช้จ่ายของผู้เช่าซื้อเอง บรรดาเงินที่ ผู้เช่าซื้อชำระมาแล้ว ให้ตกเป็นของผู้ให้เช่าซื้อทั้งสิ้น และผู้เช่าซื้อตกลงให้ผู้ให้เช่าซื้อดำเนินการและตกลงรับผิดตาม ที่กำหนดไว้ในข้อ 13'

    const addIn15A = spaceParam + 'ข้อ 15. เมื่อผู้เช่าซื้อได้ชำระเงินค่าเช่าซื้อ และค่าใช้จ่ายที่ผู้ให้เช่าซื้อเรียกเก็บได้ตามกฎหมายที่เกี่ยวข้องครบ ถ้วนแล้ว ให้กรรมสิทธิ์ทรัพย์สินที่เช่าซื้อตกเป็นของผู้เช่าซื้อทันทีและเจ้าของจะโอนกรรมสิทธิ์ทรัพย์สินที่เช่าซื้อ ให้แก่ผู้เช่าซื้อภายใน 30 (สามสิบ) วัน นับแต่วันที่เจ้าของได้รับเอกสารที่จำเป็นสำหรับการโอนกรรมสิทธิ์จาก ผู้เช่าซื้อครบถ้วนและไม่เป็นกรณีที่มีเหตุขัดข้องที่ไม่สามารถทำการโอนกรรมสิทธิ์ได้โดยไม่ใช่ความผิดของเจ้าของ โดยผู้เช่าซื้อต้องชำระค่าธรรมเนียมการโอนกรรมสิทธิ์ทรัพย์สินที่เช่าซื้อเองหากล่วงเลยกำหนดดังกล่าว เจ้าของ ยินยอมเสียเบี้ยปรับโดยคำนวณจากมูลค่าเช่าซื้อในอัตราเท่ากับอัตราเบี้ยปรับที่ระบุไว้ในข้อ 15. วรรคสองไปจนกว่า จะดำเนินการเสร็จสิ้น และถ้าผู้เช่าซื้อต้องดำเนินคดีทางศาลเพื่อเรียกร้องค่าเสียหายหรือเบี้ยปรับ เจ้าของจะรับ ภาระค่าธรรมเนียม ค่าทนายความ ตามความเป็นจริงอันจำเป็นและมีเหตุอันสมควร หรือค่าใช้จ่ายอื่นใดที่เกี่ยวข้อง ในการดำเนินคดีดังกล่าวแก่ผู้เช่าซื้อ หากเจ้าของได้รับความเสียหายใดๆ จากการไม่สามารถโอนกรรมสิทธิ์ทรัพย์ ที่เช่าซื้อให้แก่ผู้เช่าซื้อไม่ว่ากรณีใดๆ ผู้เช่าซื้อต้องชดใช้ค่าเสียหายให้แก่เจ้าของเต็มจำนวนตามที่เจ้าของแจ้งให้ทราบ และในกรณีที่ผู้เช่าซื้อผิดนัดไม่ชำระค่าเช่าซื้อ หรือประพฤติผิดสัญญาเช่าซื้อฉบับอื่นใดที่มีอยู่กับเจ้าของ เจ้าของมี สิทธิระงับการโอนกรรมสิทธิ์ทรัพย์สินที่เช่าซื้อ หรือไม่ส่งมอบใบคู่มือจดทะเบียนพร้อมเอกสารชุดโอนตามสัญญานี้ ให้กับผู้เช่าซื้อได้'

    const addIn16A = spaceParam + 'ข้อ 16. กรณีที่ผู้เช่าซื้อผิดนัดไม่ชำระค่าเช่าซื้อ และ / หรือเงินจำนวนใดๆ ตามกำหนดตามข้อ 15. ผู้เช่าซื้อ ตกลงชำระเบี้ยปรับของค่าเช่าซื้อ และ / หรือเงินจำนวนใดๆ ที่ผิดนัด รวมถึงค่าธรรมเนียม หรือค่าใช้จ่ายใดๆ ในการทวงถามหนี้ค่าเช่าซื้อ ตามที่คณะกรรมการกำกับการทวงถามหนี้ ประกาศกำหนดตามกฎหมายว่าด้วยการ ทวงถามหนี้โดยวิธีการคิดคำนวณ รายละเอียดปรากฏตามตารางแสดงอัตราค่าธรรมเนียม หรือค่าใช้จ่ายใดๆ ในการ ทวงถามหนี้ค่าเช่าซื้อ ที่แนบท้ายสัญญาฉบับนี้ และถือว่าเป็นส่วนหนึ่งของสัญญานี้ แต่ต่อไปอาจมีการเปลี่ยนแปลง ได้ตามประกาศกำหนดของคณะกรรมการกำกับการทวงถามหนี้ดังกล่าวอย่างไรก็ตาม ในกรณีที่ยังไม่มีประกาศของ คณะกรรมการกำกับการทวงถามหนี้ ผู้เช่าซื้อตกลงให้เจ้าของเรียกเก็บค่าธรรมเนียม หรือค่าใช้จ่ายใดๆ ในการทวง ถามหนี้ค่าเช่าซื้อตามสัญญานี้ ได้เพียงเท่าที่ธนาคารได้ใช้จ่ายไปจริง โดยประหยัด ตามความจำเป็นและมีเหตุอัน สมควร โดยให้เป็นไปตามอัตราและรายละเอียดที่กำหนดอยู่ในประกาศของเจ้าของในเรื่องดังกล่าว'
    const addIn16B = spaceParam + spaceParam + 'เบี้ยปรับตามที่ระบุไว้ในสัญญานี้ ผู้เช่าซื้อตกลงชำระให้แก่เจ้าของในอัตราเท่ากับ “อัตราดอกเบี้ยที่แท้จริง” บวกด้วยร้อยละ 3 ต่อปี แต่ไม่เกินกว่าอัตราร้อยละ 15 (สิบห้า) ต่อปี ซึ่ง ณ วันทำ สัญญานี้ “อัตราดอกเบี้ยที่แท้จริง” เท่ากับอัตราดอกเบี้ยที่ระบุไว้ในรายละเอียดทรัพย์สินที่เช่าซื้อและค่าเช่า ซื้อตามข้อ 1. ของสัญญาเช่าซื้อ และเบี้ยปรับดังกล่าวเจ้าของจะเรียกให้ผู้เช่าซื้อชำระทันที หรือรวมเรียกเก็บ เมื่อผู้เช่าซื้อชำระค่าเช่าซื้องวดสุดท้ายก็ได้ และให้ถือว่าเจ้าของได้สงวนสิทธิเรียกร้องค่าสินไหมทดแทน ดังกล่าวไว้แล้วในเวลารับชำระหนี้'

    const addIn17A = spaceParam + 'ข้อ 17. ในสัญญานี้ความหมายของคำว่า “ หนี้คงค้างชำระตามสัญญานี้” ให้หมายความถึงยอดรวมของ'
    const addIn17B = spaceParam + spaceParam + '17.1 ค่าเช่าซื้อที่ผิดนัดชำระ เบี้ยปรับ ค่าใช้จ่าย หรือหนี้อื่นๆ ที่คงค้างทั้งหมด และ'
    const addIn17C = spaceParam + spaceParam + '17.2 ค่าเช่าซื้อที่ยังไม่ถึงกำหนดชำระทั้งหมด และ'
    const addIn17D = spaceParam + spaceParam + '17.3 ภาษีมูลค่าเพิ่ม ค่าเบี้ยประกันภัย ค่าธรรมเนียม ค่าภาษีหรือค่าใช้จ่ายใดๆ ที่ผู้เช่าซื้อมีหน้าที่ต้อง ชำระตามกฎหมายหรือตามสัญญานี้ ทั้งนี้ ไม่ว่าเจ้าของจะได้จ่ายไปแทนในนามผู้เช่าซื้อ หรือ ในนามเจ้าของหรือ ไม่ก็ตาม ผู้เช่าซื้อจะต้องชำระคืนให้แก่เจ้าของพร้อมเบี้ยปรับของเงินดังกล่าว (ถ้ามี)'
    const addIn17E = spaceParam + spaceParam + '17.4 ค่าธรรมเนียมหรือค่าใช้จ่ายใดๆ ในการทวงถามหนี้ค่าเช่าซื้อ ตามที่รายละเอียดการคิดคำนวณแต่ ละรายการ ปรากฏตามเอกสารที่แนบท้ายสัญญานี้'
    const addIn17F = spaceParam + spaceParam + 'ในกรณีที่ผู้เช่าซื้อมีความประสงค์จะขอชำระเงินค่าเช่าซื้อทั้งหมดในคราวเดียวโดยไม่ผ่อนชำระค่าเช่าซื้อ เป็นรายงวดตามสัญญา เพื่อปิดบัญชีค่าเช่าซื้อ เจ้าของตกลงให้ส่วนลดแก่ผู้เช่าซื้อในอัตรา ร้อยละ 50 (ห้าสิบ) ของดอกเบี้ยเช่าซื้อที่ยังไม่ถึงกำหนดชำระ โดยคิดคำนวณตามมาตรฐานการบัญชีว่าด้วยเรื่อง สัญญาเช่า ตามที่คณะกรรมการกำหนดมาตรฐานการบัญชีตามกฎหมายว่าด้วยวิชาชีพบัญชีกำหนดและปรับปรุงมาตรฐานการ บัญชี เพื่อใช้เป็นมาตรฐานในการจัดทำบัญชีตามกฎหมายว่าด้วยการบัญชีและกฎหมายอื่น รายละเอียดปรากฏตาม ตารางแสดงภาระหนี้ตามสัญญาเช่าซื้อที่แนบท้ายสัญญาฉบับนี้'

    const addIn18A = spaceParam + 'ข้อ 18. หากมีเงินหรือทรัพย์สินใดๆ ของผู้เช่าซื้ออยู่กับเจ้าของตามตั๋วเงินหรือตามบัญชีประเภทใดและ / หรือมี เงินหรือทรัพย์สินใดๆ ที่จะตกให้แก่ผู้เช่าซื้อ แต่อยู่ในความครอบครองของเจ้าของ และ / หรือมีเงินและ / หรือมี หนี้สิน หรือทรัพย์สินใดๆ ที่เจ้าของจะต้องชำระหรือคืนให้แก่ผู้เช่าซื้อ ผู้เช่าซื้อยินยอมให้เจ้าของหักเอาเงิน และ / หรือหนี้สิน และ / หรือขายทรัพย์สินมาใช้หนี้ความรับผิดชอบผู้เช่าซื้อตามสัญญานี้ได้ทั้งสิ้น หากยังขาด อยู่เท่าใด ผู้เช่าซื้อยังต้องผูกพันตามสัญญานี้จนกว่าเจ้าของจะได้รับชำระหนี้ครบถ้วน'
    const addIn19A = spaceParam + 'ข้อ 19. การบอกกล่าว ติดต่อ หรือการส่งเอกสารอื่นใดอันเกี่ยวข้องสัญญานี้จากผู้เช่าซื้อไปยังเจ้าของ เพื่อให้มี ผลผูกพันตามกฎหมายจะต้องทำเป็นลายลักษณ์อักษร และส่งทางไปรษณีย์ไปยังผู้รับ'
    const addIn19B = spaceParam + spaceParam + 'ทั้งนี้ ในกรณีที่มีกฎหมาย หรือข้อสัญญาใดตามสัญญานี้ กำหนดให้เจ้าของแจ้งหรือบอกกล่าวเป็นหนังสือ ไปยังผู้เช่าซื้อ เจ้าของจะแจ้งหรือบอกกล่าวโดยทางไปรษณีย์ลงทะเบียนตอบรับให้แก่ผู้เช่าซื้อ ตามที่อยู่ที่ระบุไว้ ในสัญญา หรือที่อยู่ที่ผู้เช่าซื้อได้แจ้งการเปลี่ยนแปลงไว้เป็นหนังสือครั้งหลังสุด เว้นแต่กรณีที่ผู้เช่าซื้อได้แสดงความ ประสงค์เป็นหนังสือเพื่อขอรับคำบอกกล่าวทางจดหมายอิเล็กทรอนิกส์ให้เจ้าของทราบแล้ว แต่ไม่ได้เป็นการตัดสิทธิ เจ้าของที่จะแจ้งหรือบอกกล่าวเป็นหนังสือไปยังผู้ให้เช่าซื้อควบคู่กันไปด้วย ในกรณีที่ผู้เช่าซื้อเปลี่ยนแปลงที่อยู่ไป จากที่ระบุไว้ในสัญญานี้ ผู้เช่าซื้อต้องแจ้งให้เจ้าของทราบที่อยู่แห่งใหม่เป็นหนังสือภายใน 7 (เจ็ด) วัน นับแต่วันที่มีการเปลี่ยนแปลง'

    const addIn20A = spaceParam + 'ข้อ 20. ในกรณีที่ผู้เช่าซื้อผิดนัดชำระค่าเช่าซื้อ และเจ้าของไม่ใช้สิทธิบอกเลิกสัญญาตามข้อ 10.1 โดยยินยอมให้ ผู้เช่าซื้อชำระค่าเช่าซื้อหรือเงินจำนวนใดๆ ที่ผิดนัด ตามสัญญาข้อ 15. ต่อไป ผู้เช่าซื้อหรือบุคคลซึ่งต้องร่วมรับผิด กับผู้เช่าซื้อ ยังต้องปฏิบัติตามข้อกำหนดของสัญญาที่เป็นเหตุให้มีการผิดนัด โดยเคร่งครัดและให้ถือว่าข้อสัญญา ที่กำหนดเวลาชำระค่าเช่าซื้อเป็นสาระสำคัญของสัญญาและรับรองว่าจะไม่ให้มีการผิดนัดชำระค่าเช่าซื้ออีกต่อไป'
    const addIn21A = spaceParam + 'ข้อ 21. ผู้เช่าซื้อตกลงจัดหาผู้ค้ำประกันเพื่อค้ำประกันหนี้สินใดๆ ตามสัญญานี้ทันทีที่เจ้าของร้องขอโดยเจ้าของ จะจัดให้มีการทำสัญญาค้ำประกันและคำเตือนสำหรับผู้ค้ำประกันตามแบบและวิธีการที่เจ้าของกำหนดข้อ'
    const addIn22A = spaceParam + 'ข้อ 22. หากสัญญานี้ข้อหนึ่งข้อใดเป็นโมฆะหรือไม่สมบูรณ์ คู่สัญญาตกลงให้ถือว่าส่วนที่ไม่โมฆะหรือสมบูรณ์ แยกออกจากส่วนที่เป็นโมฆะหรือไม่สมบูรณ์นั้น และมีผลใช้บังคับได้ และแบบคำขอทำสัญญาเช่าซื้อให้ถือเป็น ส่วนหนึ่งของสัญญานี้ด้วย'

    const addIn23A = spaceParam + 'ข้อ 23. ผู้เช่าซื้อตกลงยินยอมให้เจ้าของเก็บ รวบรวม ตรวจสอบ ใช้ ติดต่อสอบถาม หรือเปิดเผยข้อมูลใดๆ ของผู้เช่าซื้อ เพื่อประโยชน์ในการที่ผู้เช่าซื้อขอรับ และ / หรือได้รับสินเชื่อ และ / หรือใช้บริการต่างๆจากเจ้าของ หรือเพื่อการพัฒนาและปรับปรุงการให้บริการของเจ้าของ หรือเปิดเผยข้อมูลให้พันธมิตรทางธุรกิจที่ออกผลิตภัณฑ์ ร่วมกัน (co-brand) หรือเพื่อวัตถุประสงค์อื่นใดที่มิใช่การตลาด เช่น เพื่อประโยชน์ในการติดตามทวงถามหนี้ได้ ตามที่เจ้าของเห็นสมควรและภายใต้กฎหมายที่เกี่ยวข้องกำหนด รวมทั้ง ในกรณีที่เจ้าของได้ใช้บริการจากบุคคล ภายนอก (Outsourcing) เพื่อสนับสนุนการให้บริการของเจ้าของผู้เช่าซื้อ ตกลงยินยอมให้เจ้าของเปิดเผยข้อมูล ของผู้เช่าซื้อแก่บุคคลภายนอก (Outsourcing) ได้ โดยเจ้าของจะควบคุมดูแลบุคคลภายนอก (Outsourcing) ในการเก็บรักษาข้อมูลของผู้เช่าซื้อตามที่กฎหมายกำหนด'

    const addInEnd = spaceParam + 'สัญญาฉบับนี้ทำขึ้นเป็นสองฉบับมีข้อความถูกต้องตรงกัน มอบไว้ให้แก่คู่สัญญาเก็บรักษาไว้ฝ่ายละฉบับ คู่สัญญา ได้อ่านและเข้าใจข้อความในสัญญานี้โดยตลอดแล้ว จึงได้ลงลายมือชื่อไว้เป็นสำคัญต่อหน้าพยาน ณ วัน เดือน ปี ดังปรากฏข้างต้น'

    let tableSignAddIn = {
      margin: [15, 10, 0, 10],
      layout: 'noBorders', // optional
      table: {
        widths: ['15%', '75%', '10%'],
        body: [
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................ผู้เช่าซื้อ', lineHeight:1.5 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................เจ้าของ', lineHeight:1.5 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................พยาน', lineHeight:1.5 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................พยาน', lineHeight:1.5 },
            { text: '' },
          ],
        ]
      }
    }

    // TODO: สัญญาค้ำประกัน
    const sell_guarantor_name = car_sell.sell_guarantor_name
    const sell_guarantor_address = car_sell.sell_guarantor_address
    const sell_guarantor_name2 = car_sell.sell_guarantor_name2 === '' ? '....................................................' : car_sell.sell_guarantor_name2
    const sell_guarantor_address2 = car_sell.sell_guarantor_address2 === '' ?
                                    '.............................................................................................' : car_sell.sell_guarantor_address2

    const guaranteeContractInfo01 = spaceParam + 'สัญญาค้ำประกันสัญญาเช่าซื้อรถยนต์  เลขที่สัญญา '+ contract_number+ ' '
    const guaranteeContractInfo02 = 'ทำสัญญาที่ '+ branch_name+' เมื่อวันที่ ' + contact_date
    const guaranteeContractInfo03 = spaceParam + '1. ข้าพเจ้า ' + sell_guarantor_name
    const guaranteeContractInfo04 = 'อยู่บ้านเลขที่ ' + sell_guarantor_address
    const guaranteeContractInfo07 = spaceParam + '2. ข้าพเจ้า ' + sell_guarantor_name2
    const guaranteeContractInfo08 = 'อยู่บ้านเลขที่ ' + sell_guarantor_address2
    const guaranteeContractInfo05 = spaceParam + 'ได้ตกลงทำสัญญาค้ำประกันให้ไว้แก่ ' +branch_name
    const guaranteeContractInfo06 = 'ซึ่งต่อไปในสัญญาเรียกว่า “บริษัท/ร้านค้า” มีข้อความดังต่อไปนี้ '

    const guaranteeContractOrder01A = spaceParam + 'ข้อที่ 1. ตามที่ '+customer_name +' ผู้เช่าซื้อ ได้ทำสัญญาเช่าซื้อเลขที่ '+contract_number+' ลงวันที่ '+ contact_date+' นั้น'
    const guaranteeContractOrder01B = spaceParam + 'ถ้าผู้เช่าซื้อจะต้องรับผิดชอบชดใช้เงินตามสัญญาดังกล่าวแก่บริษัทก็ดีจะต้องรับผิดชอบชดใช้ค่าเสียหายใดๆ แก่บริษัท ก็ดี ข้าพเจ้ายอมค้ำประกันและยอมรับผิดเป็นลูกหนี้ร่วมกับผู้เช่าซื้อทุกประการและยอมให้บริษัทผ่อนผันการชำระหนี้ได้ตาม ที่บริษัทเห็นสมควร ยอมให้บริษัทเปลี่ยนแปลงแก้ไข เพิ่มเติมข้อสัญญาใดๆ จำนวนหนี้สินหรือสภาพแห่งหนี้สินของสัญญาได้ ทุกประการ และข้าพเจ้าสัญญาว่าจะไม่บอกเลิกสัญญาค้ำประกันฉบับนี้ เว้นแต่บริษัทยินยอมเป็นหนังสือให้บอกเลิกได้'

    const guaranteeContractOrder02A = spaceParam + 'ข้อ 2. ข้าพเจ้ายอมสละข้อต่อสู้ของข้าพเจ้าที่มีต่อบริษัทในอันที่จะถือเอาประโยชน์จากข้อต่อสู้ใดๆ ของผู้เช่าซื้อที่มีต่อ บริษัทหรือตลอดทั้งบรรดาสิทธิอื่นๆ ของการค้ำประกันที่มีอยู่ตามกฎหมายต่อบริษัท และข้าพเจ้ายินยอมรับผิดตามสัญญา ค้ำประกันนี้ทุกประการแห่งหนี้สินทั้งหลายของผู้เช่าซื้อแม้ว่าหนี้นั้นได้เกิดหรือเกิดจากโมฆียะกรรมของผู้เช่าซื้อหรือความ ไม่บริบูรณ์ในการทำสัญญาของผู้เช่าซื้อ'
    const guaranteeContractOrder02B = spaceParam + 'ในกรณีที่ผู้เช่าซื้อผิดนัดไม่ชำระค่าเช่าซื้อ และบริษัทได้มีหนังสือบอกเลิกสัญญา มีผลให้สัญญา  เช่าซื้อสิ้นสุดลงหรือ บริษัทได้รับทรัพย์สินที่เช่าซื้อกลับคืนมาไม่ว่าสัญญาเช่าซื้อจะอจะสิ้นสุดลงหรือไม่ก็ตามหากผู้เช่าซื้อขอเช่าซื้อต่อไปโดย บริษัท ตกลงยินยอมและผู้เช่าซื้อได้ครอบครองทรัพย์สินที่เช่าซื้อตามข้อตกลงและเงื่อนไขในสัญญาเช่าซื้อต่อไป ข้าพเจ้าตกลงค้ำประกันผู้เช่าซื้อตามความในสัญญาและเงื่อนไขในการค้ำประกันนี้ต่อไป'

    const guaranteeContractOrder03A = spaceParam + 'ข้อ 3. ในกรณีที่บริษัทส่งเอกสาร หนังสือบอกกล่าวหรือหนังสือใดๆ ให้แก่ผู้ค้ำประกันตามสถานที่อยู่ของผู้ค้ำประกัน ตามสัญญานี้โดยมิต้องคำนึงว่าจะมีผู้รับหรือไม่ หรือแม้หากส่งไม่ได้เพราะผู้ค้ำประกันย้ายที่อยู่หรือสถานที่ดังกล่าว เปลี่ยนแปลงไป หรือถูกรื้อถอนหรือถูกไฟไหม้ หรือส่งไม่ได้เพราะหาสถานที่ตามที่ระบุไว้ไม่พบก็ให้ถือว่าผู้ค้ำประกันได้รับ เอกสารหรือหนังสือดังกล่าวโดยชอบแล้ว'
    const guaranteeContractOrder03B = spaceParam + spaceParam + spaceParam + 'เพื่อเป็นหลักฐานแห่งสัญญานี้ ข้าพเจ้าจึงได้ลงลายมือชื่อให้ไว้ต่อหน้าพยานเป็นสำคัญ'

    let tableSignGuaranteeContract = {
      margin: [10, 8, 0, 8],
      layout: 'noBorders', // optional
      table: {
        widths: ['15%', '75%', '10%'],
        body: [
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................ผู้ค้ำประกัน', lineHeight:1.2 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................ผู้ค้ำประกัน', lineHeight:1.2 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................พยาน', lineHeight:1.2 },
            { text: '' },
          ],
          [
            { text: '' },
            { text: 'ลงชื่อ.......................................................................................พยาน', lineHeight:1.2 },
            { text: '' },
          ],
        ]
      }
    }

    // margin: [left, top, right, bottom]
    // pageMargins: [70, 50, 50, 30],
    const docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [40, 50, 40, 40],
      header: function (currentPage, pageCount, pageSize) {
        // you can apply any logic and return any valid pdfmake element
        return [
          {
            margin: [30, 30, 30, 0],
            layout: 'noBorders', // optional
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    layout: 'noBorders',
                    table: {
                      widths: ['80%', '20%'],
                      body: [
                        [
                          { text: 'Printed Date : ' + printDate },
                          { text: 'Page ' + currentPage + ' of ' + pageCount, style: 'right' }
                        ]
                      ]
                    }
                  }
                ]
              ]
            }
          }
        ]
      },

      content: [
        { text: 'สัญญาเช่าซื้อ', style: 'header', margin: [0, 0, 0, 8], },
        { text: contentInfo, margin: [0, 0, 0, 5], },
        { text: order01, margin: [0, 0, 0, 5], },
        { text: order02, margin: [0, 0, 0, 5], },
        { text: order03, margin: [0, 0, 0, 5], },
        tableCalculate,
        pageBreak,
        tableCalculate2,
        {text: spaceParam + '     ' + 'คู่สัญญาได้อ่านและเข้าใจข้อความของสัญญานี้โดยตลอดแล้ว จึงได้ลงลายมือชื่อไว้เป็นสำคัญต่อหน้าพยาน', margin: [0, 10, 0, 10]},
        tableSign,
        tableInsurancePaNote,
        pageBreak,
        { text: 'สัญญาต่อท้ายสัญญาเช่าซื้อ', style: 'header', margin: [0, 0, 0, 8], },
        { text: addIn01A, margin: [0, 0, 0, 6], },
        { text: addIn01B, margin: [0, 0, 0, 6], },
        { text: addIn01C, margin: [0, 0, 0, 6], },
        // 2
        { text: addIn02A, margin: [0, 0, 0, 6], },
        { text: addIn02B, margin: [0, 0, 0, 6], },
        { text: addIn02C, margin: [0, 0, 0, 6], },
        { text: addIn02D, margin: [0, 0, 0, 6], },
        { text: addIn02E, margin: [0, 0, 0, 6], },
        { text: addIn02F, margin: [0, 0, 0, 6], },
        { text: addIn02G, margin: [0, 0, 0, 6], },
        // 3
        { text: addIn03A, margin: [0, 0, 0, 6], },
        { text: addIn03B, margin: [0, 0, 0, 6], },
        // 4
        { text: addIn04A, margin: [0, 0, 0, 6], },
        // 5
        { text: addIn05A, margin: [0, 0, 0, 6], },
        { text: addIn05B, margin: [0, 0, 0, 6], },
        // 6
        { text: addIn06A, margin: [0, 0, 0, 6], },
        { text: addIn06B, margin: [0, 0, 0, 6], },
        // 7
        { text: addIn07A, margin: [0, 0, 0, 6], },
        { text: addIn07B, margin: [0, 0, 0, 6], },
        { text: addIn07C, margin: [0, 0, 0, 6], },
        // 8
        { text: addIn08A, margin: [0, 0, 0, 6], },
        { text: addIn08B, margin: [0, 0, 0, 6], },
        { text: addIn08C, margin: [0, 0, 0, 6], },
        // 9
        { text: addIn09A, margin: [0, 0, 0, 6], },
        { text: addIn09B, margin: [0, 0, 0, 6], },
        { text: addIn09C, margin: [0, 0, 0, 6], },
        { text: addIn09D, margin: [0, 0, 0, 6], },
        // 10
        { text: addIn10A, margin: [0, 0, 0, 6], },
        { text: addIn10B, margin: [0, 0, 0, 6], },
        { text: addIn10C, margin: [0, 0, 0, 6], },
        { text: addIn10D, margin: [0, 0, 0, 6], },
        { text: addIn10E, margin: [0, 0, 0, 6], },
        { text: addIn10F, margin: [0, 0, 0, 6], },
        { text: addIn10G, margin: [0, 0, 0, 6], },
        { text: addIn10H, margin: [0, 0, 0, 6], },
        // 11
        { text: addIn11A, margin: [0, 0, 0, 6], },
        { text: addIn11B, margin: [0, 0, 0, 6], },
        // 12
        { text: addIn12A, margin: [0, 0, 0, 6], },
        // 13
        { text: addIn13A, margin: [0, 0, 0, 6], },
        { text: addIn13B, margin: [0, 0, 0, 6], },
        { text: addIn13C, margin: [0, 0, 0, 6], },
        { text: addIn13D, margin: [0, 0, 0, 6], },
        { text: addIn13E, margin: [0, 0, 0, 6], },
        { text: addIn13F, margin: [0, 0, 0, 6], },
        { text: addIn13G, margin: [0, 0, 0, 6], },
        { text: addIn13H, margin: [0, 0, 0, 6], },
        // 14
        { text: addIn14A, margin: [0, 0, 0, 6], },
        { text: addIn15A, margin: [0, 0, 0, 6], },
        { text: addIn16A, margin: [0, 0, 0, 6], },
        { text: addIn16B, margin: [0, 0, 0, 6], },
        // 17
        { text: addIn17A, margin: [0, 0, 0, 6], },
        { text: addIn17B, margin: [0, 0, 0, 6], },
        { text: addIn17C, margin: [0, 0, 0, 6], },
        { text: addIn17D, margin: [0, 0, 0, 6], },
        { text: addIn17E, margin: [0, 0, 0, 6], },
        { text: addIn17F, margin: [0, 0, 0, 6], },
        // 18
        { text: addIn18A, margin: [0, 0, 0, 6], },
        { text: addIn19A, margin: [0, 0, 0, 6], },
        { text: addIn19B, margin: [0, 0, 0, 6], },
        { text: addIn20A, margin: [0, 0, 0, 6], },
        { text: addIn21A, margin: [0, 0, 0, 6], },
        { text: addIn22A, margin: [0, 0, 0, 6], },
        { text: addIn23A, margin: [0, 0, 0, 6], },
        { text: addInEnd, margin: [0, 0, 0, 6], },
        tableSignAddIn,
        pageBreak,
        { text: 'สัญญาค้ำประกัน', style: 'header', margin: [0, 0, 0, 10], },
        { text: guaranteeContractInfo01 +' '+ guaranteeContractInfo02, margin: [4, 0, 4, 5], },
        { text: guaranteeContractInfo03 +' '+ guaranteeContractInfo04, margin: [4, 0, 4, 5], },
        { text: guaranteeContractInfo07 +' '+ guaranteeContractInfo08, margin: [4, 0, 4, 5], },
        { text: guaranteeContractInfo05 +' '+ guaranteeContractInfo06, margin: [4, 0, 4, 5], },
        { text: guaranteeContractOrder01A, margin: [4, 0, 4, 5], },
        { text: guaranteeContractOrder01B, margin: [4, 0, 4, 5], },
        { text: guaranteeContractOrder02A, margin: [4, 0, 4, 5], },
        { text: guaranteeContractOrder02B, margin: [4, 0, 4, 5], },
        { text: guaranteeContractOrder03A, margin: [4, 0, 4, 5], },
        { text: guaranteeContractOrder03B, margin: [4, 0, 4, 5], },
        tableSignGuaranteeContract
      ],
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 15,
      },

      styles: {
        right: {
          alignment: 'right'
        },
        center: {
          alignment: 'center'
        },
        header: {
          alignment: 'center',
          bold: true,
          fontSize: 20
        },
        left22: {
          marginLeft: 22
        },
        topic: {
          bold: true,
          fontSize: 16
        },
        noBorder: {
          bold: true,
          alignment: 'right'
        },
        lineVertical: {
          marginTop: -5
        },
        textStatus: {
          marginTop: -5,
          color: 'red'
        },
        headTable: {
          fontSize: 12,
          padding: '0 10 0 10'
        },
        table: {
          fontSize: 12
        },
        underline: {
          decoration: 'underline'
        }
      }
    };

    pdfMake.createPdf(docDefinition).open()

  }

  render () {
    return <></>
  }
}

export default SalesContractPDF
